import { useEffect } from "react";
import { useHistory } from "react-router-dom";

const ShareScreen = () => {
  const history = useHistory();

  useEffect(() => {
    setTimeout(() => {
      history.push('/referral')
    }, 100)
  }, [history])

  return <></>;
};

export default ShareScreen;
